(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header');
            this.headerIsAlwaysSticky =
                this.getAttribute('data-sticky-type') === 'always' ||
                this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};

            this.setHeaderHeight();

            window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

            if (this.headerIsAlwaysSticky) {
                this.header.classList.add('shopify-section-header-sticky');
            }

            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        setHeaderHeight() {
            document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.closeMenuDisclosure();
            this.closeSearchModal();
        }

        reveal() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
        }

        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
            this.disclosures.forEach((disclosure) => disclosure.close());
        }

        closeSearchModal() {
            this.searchModal = this.searchModal || this.header.querySelector('details-modal');
            this.searchModal.close(false);
        }
    }

    customElements.define('sticky-header', StickyHeader);

    class MegaMenuPush {
        constructor() {
            this.mainContent = document.getElementById('MainContent');
            if (!this.mainContent) return;

            this.mainContent.style.transition = 'margin-top 0.42s cubic-bezier(0.4, 0, 0.2, 1)';

            document.querySelectorAll('header-menu').forEach((headerMenuEl) => {
                const details = headerMenuEl.querySelector('details.mega-menu');
                if (!details) return;

                const summary = details.querySelector('summary');

                summary.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (details.hasAttribute('open')) {
                        this.closeWithAnimation(details, headerMenuEl);
                    } else {
                        // Diğer açık mega menüyü kapat
                        document.querySelectorAll('details.mega-menu[open]').forEach((other) => {
                            if (other !== details) {
                                const otherMenu = other.closest('header-menu');
                                this.closeWithAnimation(other, otherMenu);
                            }
                        });
                        this.open(details, headerMenuEl);
                    }
                });

                // Dışarı tıklama / focusout ile kapanma durumu
                details.addEventListener('toggle', () => {
                    if (!details.open) {
                        this.mainContent.style.marginTop = '';
                    }
                });
            });
        }

        open(details, headerMenuEl) {
            const panel = details.querySelector('.mega-menu__panel');
            if (!panel) return;

            details.setAttribute('open', '');
            details.querySelector('summary').setAttribute('aria-expanded', 'true');

            // HeaderMenu iç durumunu güncelle
            if (headerMenuEl.header) headerMenuEl.header.preventHide = true;
            if (!document.documentElement.style.getPropertyValue('--header-bottom-position-desktop')) {
                const hw = document.querySelector('.header-wrapper');
                if (hw) {
                    document.documentElement.style.setProperty(
                        '--header-bottom-position-desktop',
                        `${Math.floor(hw.getBoundingClientRect().bottom)}px`
                    );
                }
            }

            // Yüksekliği ölç (max-height: 0 olsa da scrollHeight gerçek yüksekliği verir)
            void panel.offsetHeight;
            const height = panel.scrollHeight;

            panel.style.maxHeight = height + 'px';

            // Sayfa en üstündeyken içeriği aşağı it; scroll sonrası sadece overlay aç
            const sectionHeader = document.querySelector('.section-header');
            const isAtTop = sectionHeader && !sectionHeader.classList.contains('scrolled-past-header');
            if (isAtTop) {
                this.mainContent.style.marginTop = height + 'px';
            }
        }

        closeWithAnimation(details, headerMenuEl) {
            const panel = details.querySelector('.mega-menu__panel');
            if (!panel) return;

            const sectionHeader = document.querySelector('.section-header');
            const isAtTop = sectionHeader && !sectionHeader.classList.contains('scrolled-past-header');

            const finish = () => {
                details.removeAttribute('open');
                details.querySelector('summary').setAttribute('aria-expanded', 'false');
                if (headerMenuEl && headerMenuEl.header) headerMenuEl.header.preventHide = false;
                panel.style.maxHeight = '';
            };

            this.mainContent.style.marginTop = '';

            if (!isAtTop) {
                // Sticky modda: animasyonsuz, anında kapat
                finish();
                return;
            }

            // En üstteyken: smooth kapanma animasyonu
            const currentHeight = panel.getBoundingClientRect().height;
            panel.style.maxHeight = currentHeight + 'px';
            void panel.offsetHeight;
            panel.style.maxHeight = '0';

            let finished = false;
            const finishOnce = () => {
                if (finished) return;
                finished = true;
                finish();
            };

            panel.addEventListener('transitionend', finishOnce, { once: true });
            setTimeout(finishOnce, 460);
        }
    }

    document.addEventListener('DOMContentLoaded', () => new MegaMenuPush());

  } catch(e) { console.error(e); }
})();
})();
